export type IconsId =
  | 'youTube'
  | 'wishlist'
  | 'wishlist-fill'
  | 'twitter'
  | 'tick'
  | 'stores'
  | 'signout'
  | 'shop'
  | 'share'
  | 'search'
  | 'radio-on'
  | 'radio-off'
  | 'quote'
  | 'question'
  | 'promo'
  | 'project-inline'
  | 'plus'
  | 'play'
  | 'pinterest'
  | 'phone'
  | 'minus'
  | 'menu'
  | 'lock'
  | 'linkedin'
  | 'instagram'
  | 'info'
  | 'home'
  | 'help-info'
  | 'geo'
  | 'geo-direction'
  | 'filters'
  | 'file'
  | 'facebook'
  | 'eye'
  | 'email'
  | 'download'
  | 'delivery'
  | 'credit-notes'
  | 'close'
  | 'clock'
  | 'chevron-up'
  | 'chevron-right'
  | 'chevron-left'
  | 'chevron-down'
  | 'checkbox'
  | 'checkbox-checked'
  | 'card'
  | 'calendar'
  | 'calc'
  | 'branch'
  | 'basket'
  | 'arrow-up'
  | 'arrow-right'
  | 'arrow-left'
  | 'arrow-down'
  | 'account';

export type IconsKey =
  | 'YouTube'
  | 'Wishlist'
  | 'WishlistFill'
  | 'Twitter'
  | 'Tick'
  | 'Stores'
  | 'Signout'
  | 'Shop'
  | 'Share'
  | 'Search'
  | 'RadioOn'
  | 'RadioOff'
  | 'Quote'
  | 'Question'
  | 'Promo'
  | 'ProjectInline'
  | 'Plus'
  | 'Play'
  | 'Pinterest'
  | 'Phone'
  | 'Minus'
  | 'Menu'
  | 'Lock'
  | 'Linkedin'
  | 'Instagram'
  | 'Info'
  | 'Home'
  | 'HelpInfo'
  | 'Geo'
  | 'GeoDirection'
  | 'Filters'
  | 'File'
  | 'Facebook'
  | 'Eye'
  | 'Email'
  | 'Download'
  | 'Delivery'
  | 'CreditNotes'
  | 'Close'
  | 'Clock'
  | 'ChevronUp'
  | 'ChevronRight'
  | 'ChevronLeft'
  | 'ChevronDown'
  | 'Checkbox'
  | 'CheckboxChecked'
  | 'Card'
  | 'Calendar'
  | 'Calc'
  | 'Branch'
  | 'Basket'
  | 'ArrowUp'
  | 'ArrowRight'
  | 'ArrowLeft'
  | 'ArrowDown'
  | 'Account';

export enum Icons {
  YouTube = 'youTube',
  Wishlist = 'wishlist',
  WishlistFill = 'wishlist-fill',
  Twitter = 'twitter',
  Tick = 'tick',
  Stores = 'stores',
  Signout = 'signout',
  Shop = 'shop',
  Share = 'share',
  Search = 'search',
  RadioOn = 'radio-on',
  RadioOff = 'radio-off',
  Quote = 'quote',
  Question = 'question',
  Promo = 'promo',
  ProjectInline = 'project-inline',
  Plus = 'plus',
  Play = 'play',
  Pinterest = 'pinterest',
  Phone = 'phone',
  Minus = 'minus',
  Menu = 'menu',
  Lock = 'lock',
  Linkedin = 'linkedin',
  Instagram = 'instagram',
  Info = 'info',
  Home = 'home',
  HelpInfo = 'help-info',
  Geo = 'geo',
  GeoDirection = 'geo-direction',
  Filters = 'filters',
  File = 'file',
  Facebook = 'facebook',
  Eye = 'eye',
  Email = 'email',
  Download = 'download',
  Delivery = 'delivery',
  CreditNotes = 'credit-notes',
  Close = 'close',
  Clock = 'clock',
  ChevronUp = 'chevron-up',
  ChevronRight = 'chevron-right',
  ChevronLeft = 'chevron-left',
  ChevronDown = 'chevron-down',
  Checkbox = 'checkbox',
  CheckboxChecked = 'checkbox-checked',
  Card = 'card',
  Calendar = 'calendar',
  Calc = 'calc',
  Branch = 'branch',
  Basket = 'basket',
  ArrowUp = 'arrow-up',
  ArrowRight = 'arrow-right',
  ArrowLeft = 'arrow-left',
  ArrowDown = 'arrow-down',
  Account = 'account',
}

export const ICONS_CODEPOINTS: { [key in Icons]: string } = {
  [Icons.YouTube]: '61697',
  [Icons.Wishlist]: '61698',
  [Icons.WishlistFill]: '61699',
  [Icons.Twitter]: '61700',
  [Icons.Tick]: '61701',
  [Icons.Stores]: '61702',
  [Icons.Signout]: '61703',
  [Icons.Shop]: '61704',
  [Icons.Share]: '61705',
  [Icons.Search]: '61706',
  [Icons.RadioOn]: '61707',
  [Icons.RadioOff]: '61708',
  [Icons.Quote]: '61709',
  [Icons.Question]: '61710',
  [Icons.Promo]: '61711',
  [Icons.ProjectInline]: '61712',
  [Icons.Plus]: '61713',
  [Icons.Play]: '61714',
  [Icons.Pinterest]: '61715',
  [Icons.Phone]: '61716',
  [Icons.Minus]: '61717',
  [Icons.Menu]: '61718',
  [Icons.Lock]: '61719',
  [Icons.Linkedin]: '61720',
  [Icons.Instagram]: '61721',
  [Icons.Info]: '61722',
  [Icons.Home]: '61723',
  [Icons.HelpInfo]: '61724',
  [Icons.Geo]: '61725',
  [Icons.GeoDirection]: '61726',
  [Icons.Filters]: '61727',
  [Icons.File]: '61728',
  [Icons.Facebook]: '61729',
  [Icons.Eye]: '61730',
  [Icons.Email]: '61731',
  [Icons.Download]: '61732',
  [Icons.Delivery]: '61733',
  [Icons.CreditNotes]: '61734',
  [Icons.Close]: '61735',
  [Icons.Clock]: '61736',
  [Icons.ChevronUp]: '61737',
  [Icons.ChevronRight]: '61738',
  [Icons.ChevronLeft]: '61739',
  [Icons.ChevronDown]: '61740',
  [Icons.Checkbox]: '61741',
  [Icons.CheckboxChecked]: '61742',
  [Icons.Card]: '61743',
  [Icons.Calendar]: '61744',
  [Icons.Calc]: '61745',
  [Icons.Branch]: '61746',
  [Icons.Basket]: '61747',
  [Icons.ArrowUp]: '61748',
  [Icons.ArrowRight]: '61749',
  [Icons.ArrowLeft]: '61750',
  [Icons.ArrowDown]: '61751',
  [Icons.Account]: '61752',
};
